var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnalyticsicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_569_3438)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6671 0.255064C11.879 0.444759 12 0.715659 12 1V9.94507H20.9451C21.2294 9.94507 21.5003 10.0661 21.69 10.2779C21.8797 10.4898 21.9703 10.7723 21.939 11.0549C21.3862 16.056 17.148 19.9451 12 19.9451C6.47715 19.9451 2 15.4679 2 9.94508C2 4.79712 5.88912 0.558892 10.8901 0.00605939C11.1727 -0.025183 11.4553 0.065368 11.6671 0.255064ZM10 2.1969C6.54987 3.08468 4 6.21766 4 9.94508C4 14.3634 7.58172 17.9451 12 17.9451C15.7274 17.9451 18.8604 15.3952 19.7482 11.9451H11C10.4477 11.9451 10 11.4974 10 10.9451V2.1969ZM14.4226 0.640904C14.6877 0.453474 15.0272 0.406357 15.3332 0.514534C18.1753 1.51905 20.4261 3.76981 21.4307 6.61181C21.5388 6.91788 21.4917 7.25741 21.3043 7.52246C21.1169 7.7875 20.8124 7.94508 20.4878 7.94508H15C14.4477 7.94508 14 7.49736 14 6.94508V1.45737C14 1.13276 14.1576 0.828335 14.4226 0.640904ZM16 3.01533V5.94508H18.9298C18.2272 4.73081 17.2143 3.71793 16 3.01533Z",
    fill: "#0A0046",
    stroke: "#DFE2E9",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_569_3438"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsicon);
export default __webpack_public_path__ + "static/media/Analytics icon.f0e7d2f78d1fbac271d5308eaba19408.svg";
export { ForwardRef as ReactComponent };